import React from 'react';

export const ListaMensajes = () => {
	return [
		{
			mensaje: 'Hola esto es un mensaje',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Hola esto es otro tipo de mensaje',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Aquel dia que fuimos al parque',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Mi servicio pone que esta cancelado',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Un momento por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Compruebe ahora por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Ya funciona correctamente gracias',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'A uested',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Hola esto es un mensaje',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Hola esto es otro tipo de mensaje',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Aquel dia que fuimos al parque',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Mi servicio pone que esta cancelado',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Un momento por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Compruebe ahora por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Ya funciona correctamente gracias',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Un momento por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Compruebe ahora por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Ya funciona correctamente gracias',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
		{
			mensaje: 'Un momento por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Compruebe ahora por favor',
			horaMensaje: '12:43',
			tipo: 'mensajeSalida',
		},
		{
			mensaje: 'Ya funciona correctamente gracias',
			horaMensaje: '12:43',
			tipo: 'mensajeEntrada',
		},
	];
};
